<template lang="pug">
  .lineBar()
    .progress-container
      progress(ref="progressBar" class="amount-progress" :value="valueData" :max="max" :style="{'height': height +'px'}")

      
    
</template>

<script>


export default {
  name: 'Progress',
  components: {
  },
  props: {
    max:{
      type: Number,
      require :true,
    },
    value:{
      type: Number,
      require :true,
    },
    height:{
      type: Number,
      require :false,
      default: 8,
    },
    data:{
      type: Array,
      default: function () {
        return [
        {
          name:"Success",
          color:"#0a4bcc",
          value:20
        },
        {
          name:"Fail",
          color:"#cccccc",
          value:4
        },
        ]
      }
    }
  },
  data() {
    return {
      valueData: 0,
    };
  },
  mounted(){
    setTimeout(()=>{
      this.valueData =  this.value
    },300)
  },
  methods: {
  },
  watch:{
    'value': function (n){
      setTimeout(()=>{
      this.valueData =  n
    },5)
    }
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>





progress {
  // -webkit-appearance: none;
	// appearance: none;
	display: block;
	width: 100%;
	border: 0;
}

progress::-webkit-progress-bar {
  @apply bg-grey-cc;
}

progress::-webkit-progress-value {
  @apply bg-main-0;
	transition: width 0.5s ease-in-out;
}


// progress[value]::-webkit-progress-value {
//     // transition: width 0.5s;
// }



</style>